import { useMutation, useQuery } from "@tanstack/react-query";
import { useFormik } from "formik";
import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import useSlider from "../../hooks/useSlider";
import {
  getSupports,
  updateSupport,
} from "../../services/services";
import { toastAlert } from "../../utils/SweetAlert";
import Sidebar from "../sidebar/Sidebar";

const SupportManagement = () => {
  const isSlider = useSlider();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ keep supportId in state
  const [supportId, setSupportId] = useState(null);

  const {
    values,
    errors,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    setValues,
  } = useFormik({
    initialValues: {
      email: "",
      mobile: "",
      dialCode: "",
    },
    validationSchema: yup.object().shape({
      email: yup.string().email().required("Email is required"),
      mobile: yup.string().required("Phone Number is required"),
      dialCode: yup.string().required("Dial Code is required"),
    }),
    onSubmit: (values) => {
      if (!supportId) {
        toastAlert("error", "Support ID not found");
        return;
      }

      let body = {
        email: values?.email,
       mobile: String(values?.mobile),
        dialCode: values?.dialCode,
      };

      mutation.mutate({ id: supportId, body });
    },
  });

  // ✅ Mutation for update support
  const mutation = useMutation({
    mutationFn: ({ id, body }) => updateSupport(id, body),
    onSuccess: (resp) => {
      toastAlert("success", resp?.data?.message);
    },
  });

  // ✅ First call GET API → extract ID and prefill form
  useQuery({
    queryKey: ["support-details"],
    queryFn: async () => {
      const resp = await getSupports();
      const data = resp?.data?.data;

      if (data?._id) {
        setSupportId(data._id); // ✅ save supportId in state
        setValues({
          email: data?.email || "",
          mobile: data?.mobile || "",
          dialCode: data?.dialCode || "",
        });
      }
      return true;
    },
  });

  return (
    <div className="mainbox">
      <Sidebar />
      <div className={isSlider ? "body-content close" : "body-content open"}>
        <Row>
          <Col xl={12}>
            <h2 className="mainhead font-24">Support Management</h2>
          </Col>
        </Row>
        <div className="basic_Info">
          <Row>
            {/* Email */}
            <Col md={6}>
              <div className="mt-2">
                <label htmlFor="email" className="companyLabel">
                  Email <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="email"
                  name="email"
                  value={values?.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="commonInput"
                  placeholder="Enter Email"
                />
                <small className="text-danger ms-1">
                  {touched.email && errors.email}
                </small>
              </div>
            </Col>

            {/* Phone */}
            <Col md={6}>
              <div className="mt-2">
                <label htmlFor="mobile" className="companyLabel">
                  Phone Number <span className="text-danger">*</span>
                </label>
                <input
                 type="number"
                  id="mobile"
                  name="mobile"
                  value={values?.mobile}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="commonInput"
                  placeholder="Enter Phone Number"
                />
                <small className="text-danger ms-1">
                  {touched.mobile && errors.mobile}
                </small>
              </div>
            </Col>

            {/* Dial Code */}
            <Col md={6}>
              <div className="mt-2">
                <label htmlFor="dialCode" className="companyLabel">
                  Dial Code <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="dialCode"
                  name="dialCode"
                  value={values?.dialCode}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  style={{ textTransform: "uppercase" }}
                  className="commonInput"
                  placeholder="Enter Dial Code"
                />
                <small className="text-danger ms-1">
                  {touched.dialCode && errors.dialCode}
                </small>
              </div>
            </Col>

            {/* Submit Button */}
            <Row>
              <Col className="mt-4" xl={12}>
                <button
                  className="userBtn btn-theme m-0"
                  type="button"
                  onClick={handleSubmit}
                >
                  {t("globals.saveChanges")}
                </button>
              </Col>
            </Row>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default SupportManagement;
